import React from 'react';
import styles from './Table.module.css';
import { useTranslation } from 'react-i18next';
import Label from '../../../../components/EntToEndUI/Label/Label';
import SteelTable from '../../../../components/Tables/SteelTable/SteelTable';
import Button from '../../../../components/Buttons/Button/Button';
import RequestForm from '../../../../components/EntToEndUI/RequestForm/RequestForm';
import PropTypes from 'prop-types';
import { useScroll } from '../../../../context/ScrollContext';

const Table = ({ serviceType, steelPriceData, zincSteelPriceData }) => {
  const { t } = useTranslation();
  const { scrollTo } = useScroll();

  const handleOrderClick = () => {
    console.log('Нажата кнопка заказа в баннере');
    scrollTo('requestForm');
  };
  return (
    <section className={styles.sectionBanner}>
      <div className={styles.sectionBannerContainer}>
          <Label 
          topText={t('services.lasers.table.title')}
          bottomText={t('services.lasers.table.subTitle')}
          shift="large"
          />
        
        <div className={styles.warningRow}>
          <p>
            <a href='https://www.google.com' target='_blank' rel='noopener noreferrer'>{t('services.lasers.table.warning_link')}</a> {t('services.lasers.table.warning')}
          </p>
        </div>
        <SteelTable data={steelPriceData} title={t('services.lasers.table.tableTitle')} />
        <SteelTable data={zincSteelPriceData} title={t('services.lasers.table.zincTableTitle')} /> 
        
        <div className={styles.buttonRow}>
          <p>{t('services.lasers.table.buttonText')}</p>
          <Button 
              text={t('header.orderButton')} 
              onClick={handleOrderClick} 
              type="primary"
            />
        </div>
      </div>
    </section>
  );
};

Table.propTypes = {
  steelPriceData: PropTypes.arrayOf(PropTypes.shape({
    'Толщина, мм': PropTypes.string.isRequired,
    'До 100 м, руб': PropTypes.number.isRequired,
    'От 101 до 500 м, руб': PropTypes.number.isRequired,
    'Свыше 501 м, руб': PropTypes.number.isRequired,
    'Стоимость врезки, руб': PropTypes.string.isRequired,
    'Свыше 3000 м, руб': PropTypes.number.isRequired
  })).isRequired,
  zincSteelPriceData: PropTypes.arrayOf(PropTypes.shape({
    'Толщина, мм': PropTypes.number.isRequired,
    'До 100 м, руб': PropTypes.number.isRequired,
    'От 101 до 500 м, руб': PropTypes.number.isRequired,
    'Свыше 501 м, руб': PropTypes.number.isRequired,
    'Стоимость врезки, руб': PropTypes.number.isRequired,
    'Свыше 3000 м, руб': PropTypes.number.isRequired
  })).isRequired
};

export default Table; 